import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { iSophiVideos, tutorialsTitles, Video } from './video-tutorials-data';

@Component({
    selector: 'app-video-tutorials',
    templateUrl: './video-tutorials.component.html',
    styleUrls: ['./video-tutorials.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class VideoTutorialsComponent {
  @Input() showSection: boolean;

  @Input() licenses?: Record<string, boolean>;

  @Input() isKindergarten: boolean;

  videos: Video[] = [];

  tutorialsTitles: { [key: string]: string; } = {};

  constructor() {
    this.videos = iSophiVideos;
    this.tutorialsTitles = tutorialsTitles
  }
}
